import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IndicadorClienteAppRoutingModule } from "./indicador-cliente.app-routing.module";

@NgModule({
    imports: [
        CommonModule,
        IndicadorClienteAppRoutingModule
    ]
})
export class IndicadorClienteAppModule { }
